// Check if browser supports notifications
export const isNotificationSupported = () => {
  return 'Notification' in window;
};

// Get current permission status
export const getNotificationPermission = (): NotificationPermission | 'unsupported' => {
  if (!isNotificationSupported()) return 'unsupported';
  return Notification.permission;
};

// Request notification permission
export const requestNotificationPermission = async (): Promise<NotificationPermission | 'unsupported'> => {
  if (!isNotificationSupported()) return 'unsupported';
  
  try {
    const permission = await Notification.requestPermission();
    return permission;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return 'denied';
  }
};

// Show a browser notification
export const showBrowserNotification = (
  title: string,
  options?: NotificationOptions
): Notification | null => {
  if (!isNotificationSupported()) {
    console.warn('Browser notifications not supported');
    return null;
  }

  if (Notification.permission !== 'granted') {
    console.warn('Notification permission not granted');
    return null;
  }

  try {
    const notification = new Notification(title, {
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      ...options,
    });

    notification.onclick = () => {
      window.focus();
      notification.close();
    };

    return notification;
  } catch (error) {
    console.error('Error showing notification:', error);
    return null;
  }
};

// Show renewal reminder notification
export const showRenewalNotification = (
  toolName: string,
  daysUntilRenewal: number,
  monthlyCost?: number
) => {
  const costText = monthlyCost ? ` ($${monthlyCost}/month)` : '';
  const dayText = daysUntilRenewal === 1 ? 'day' : 'days';

  return showBrowserNotification(
    `${toolName} Renewal Reminder`,
    {
      body: `Your subscription${costText} renews in ${daysUntilRenewal} ${dayText}.`,
      tag: `renewal-${toolName}`, // Prevents duplicate notifications
      requireInteraction: daysUntilRenewal <= 1, // Keep on screen if renewal is imminent
    }
  );
};
